import { ChangeEvent } from "react";

import { Icon } from "@design-system/Icon/Icon";
import { Input } from "@design-system/Input/Input";

import classes from "./Search.module.css";

type Props = {
  onChange?: (value: string) => void;
};

export const Search = ({ onChange }: Props) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.value);
  };

  return (
    <div className={classes.search}>
      <Icon icon="faMagnifyingGlass" size="sm" />
      <Input placeholder="Search..." onChange={handleChange} transparent />
    </div>
  );
};
